export { JiraServiceDeskIcon } from './icon';
export { JiraServiceDeskLogo } from './logo';
export { JiraServiceDeskWordmark } from './wordmark';